import { Injector } from "@angular/core";
import { QueryNode } from "./QueryNode";
import { BaseNode } from "./BaseNode";
import { Art57NodeUtils } from "./Art57Node/Art57NodeUtils";
import { PaginationControl } from "../PaginationControl";
import { QueryConditionsNode } from "./QueryConditionsNode";
import { QueryFieldsNode } from "./QueryFieldsNode";

export class QueryResultNode extends BaseNode {
  paginationControl: PaginationControl = new PaginationControl();
  entityName: string = '';
  fieldsNode: QueryFieldsNode|null;
  conditionsNode: QueryConditionsNode|null;
  lastData: any;


  constructor(injector: Injector, data: any, labelTemplate: string, entityName: string, fieldsNode: QueryFieldsNode|null,conditionsNode:QueryConditionsNode|null, lastData:any) {
    super(injector, data, labelTemplate);
    this.entityName = entityName;
    this.fieldsNode = fieldsNode?fieldsNode.cloneNode(this) as QueryFieldsNode:null;
    this.conditionsNode = conditionsNode?conditionsNode.cloneNode(this) as QueryConditionsNode:null;
    this.lastData = lastData;
  }

  getListItem(): any[] {
    return [this.label];
  }

  nextPage(nodeRequest: any){
    const queryNode = (Art57NodeUtils.findFirstParentNodeOfType(this,QueryNode) as QueryNode);
    nodeRequest.paginationControl.moveNextPage();
    nodeRequest.offSet = Math.max(...nodeRequest.data.model.map((e: any) => e.num));
    queryNode!.getRecords(nodeRequest);
  }

  previousPage(nodeRequest: any){
    const queryNode = (Art57NodeUtils.findFirstParentNodeOfType(this,QueryNode) as QueryNode);
    nodeRequest.paginationControl.movePreviousPage();
    const num = (Math.min(...nodeRequest.data.model.map((e: any) => e.num)) - nodeRequest.selectedPageSize) - 1;
    nodeRequest.offSet = num < 0 ? 0 : num;
    queryNode!.getRecords(nodeRequest);
  }

  topPage(nodeRequest: any){
    const queryNode = (Art57NodeUtils.findFirstParentNodeOfType(this,QueryNode) as QueryNode);
    nodeRequest.paginationControl.moveTopPage();
    nodeRequest.offSet = 0;
    queryNode!.getRecords(nodeRequest);
  }

  //US-328923
  //RQ2: load more results besides the 50 loaded by default in the active area.
  addPage(nodeRequest: any) {
    const queryNode = (Art57NodeUtils.findFirstParentNodeOfType(this,QueryNode) as QueryNode);
    nodeRequest.paginationControl.moveNextPage();
    nodeRequest.offSet = Math.max(...nodeRequest.data.model.map((e: any) => e.num));
    queryNode!.retrieveRecords(nodeRequest, true);
  }


}